import type { DefaultError, UseMutationOptions } from "@tanstack/react-query";

import { useMutation } from "@tanstack/react-query";

import apiClient from "@/lib/api/client";

export function useMoveFilesToTrashMutation(
  options?: UseMutationOptions<unknown, DefaultError, number[]>,
) {
  return useMutation({
    mutationFn: (fileIds: number[]) =>
      apiClient
        .url("/my-files/trash")
        .post({
          fileIds: fileIds,
        })
        .res(),
    ...options,
  });
}
